import Notifications from 'react-notification-system-redux';
import { all, call, put, takeEvery } from 'redux-saga/effects';

import * as api from '../../utilities/ServiceManager';
import {
  setAllConfigsAction,
  setAllCyclesAction,
  setLoadingAction,
} from './actionSagas';
import { GET_ALL_CONFIGS, GET_ALL_CYCLES, SET_CONFIG } from './actionTypes';

function* getAllConfigs() {
  yield takeEvery(GET_ALL_CONFIGS, getAllConfigsSaga);
}

function* getAllConfigsSaga() {
  try {
    const response = yield call(api.getSelfPromotionConfigsService);
    yield put(setAllConfigsAction(response));
  } catch (exception) {
    yield put(
      Notifications.show(
        {
          title: 'Error',
          message:
            'Could not load self-promotion configs. Please try again later.',
        },
        'error',
      ),
    );
  }
}

function* getAllCycles() {
  yield takeEvery(GET_ALL_CYCLES, getAllCyclesSaga);
}

function* getAllCyclesSaga() {
  try {
    const response = yield call(api.getCycles);
    yield put(setAllCyclesAction(response.data));
  } catch (exception) {
    yield put(
      Notifications.show(
        {
          title: 'Error',
          message: 'Could not load cycles. Please try again later.',
        },
        'error',
      ),
    );
  }
}

function* setConfig() {
  yield takeEvery(SET_CONFIG, setConfigSaga);
}

function* setConfigSaga(action) {
  try {
    yield put(setLoadingAction(true));
    yield call(
      api.setSelfPromotionConfigService,
      action.cycleId,
      action.rank,
      action.enabled,
    );
    yield put(
      Notifications.show(
        {
          title: 'Done!',
          message: `Self-promotion ${action.enabled ? 'enabled' : 'disabled'} successfully.`,
          autoDismiss: 2,
        },
        'success',
      ),
    );
    const response = yield call(api.getSelfPromotionConfigsService);
    yield put(setAllConfigsAction(response));
  } catch (exception) {
    yield put(
      Notifications.show(
        {
          title: 'Error',
          message:
            'Could not update self-promotion config. Please try again later.',
        },
        'error',
      ),
    );
  } finally {
    yield put(setLoadingAction(false));
  }
}

export default function* sagas() {
  yield all([getAllConfigs(), getAllCycles(), setConfig()]);
}
